import { Redirect } from 'react-router';
import Loading from '../Loading.js';
import React from 'react'
import moment from 'moment';
import { apiService } from '../../common/apiCallService'
import { tournamentTimezone, baseUrl } from '../../common/config.js';
import TournamentWatchFilters from './TournamentWatchFilters'
import TournamentWatchDisplay from './TournamentWatchDisplay'
import OverlayChart from './overlayChart';
import { EditRegCountDialog } from './EditRegCountDialog'
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import './tournament-watch.css'
const dateFormat = 'MM/DD/YYYY HH:mm';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'

class TournamentWatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loginRedirect: false,
      editTournament: false,
      editTournamentData: {
        RegPlayersCount: 0,
        RegPlayersCount_error: 'invalid',
        tournamentId: '',
      },
      tournaments: [],
      tournamentTypeTemplates: [],
      flagTemplates: [],
      feed: [],
      displayData: [],
      filters: {
        customFilter: {
          columnName: 'default',
          min: '',
          max: ''
        },
        BuyIn: 'All',
        PrizePool: 'All',
        Overlay: 'All',
        minsToStart: 'lt 12',
        PredictedOverlay: 'All',
        tournamentType: 'All',
        flag: 'All'
      },
      sortBy: 'asc',
      sortColumn: 'minsToStart',
      lastFeedUpdateDate: null
    }
    // this.state = {
    //   loading: true,
    //   loginRedirect: false,
    //   editTournament: false,
    //   editTournamentData: {
    //     RegPlayersCount: 0,
    //     RegPlayersCount_error: 'invalid',
    //     tournamentId: '',
    //   },
    //   feed : [],
    //   tournaments: [],
    //   displayData: [],
    //   filters: {
    //     customFilter: {
    //       columnName: 'default',
    //       min: '',
    //       max: ''
    //     },
    //     BuyIn: 'All',
    //     PrizePool: 'All',
    //     Overlay: 'All',
    //     minsToStart: 'lt 12',
    //     PredictedOverlay: 'All',
    //     tournamentType: 'All',
    //     flag: 'All'
    //   },
    //   sortBy: 'asc',
    //   sortColumn: 'minsToStart',
    //   currency: [],
    //   flagTemplates: [],
    //   tournamentTypeTemplates: [],
    //   viewedTournament: null,
    //   lastUpdateDate: null
    // }
  }

  componentDidMount() {
    createVirtualPageLoad("/mttWatch")
    document.title = "MTT Watch";
    this.props.setHeaderTitle('Tournament Watch')
    Promise.all([
      this.setMetaData(),
      this.setFeed()
    ]).then(_ => {
      this.setState({ loading: false });
      setTimeout(this.setFeed, 60 * 1000);
    });
  }

  componentWillUnmount() {
    closeVirtualPage()
    document.title = "My Game";
  }

  errorRedirect = err => {
    if (err.status == 403) {
      localStorage.setItem("pathName", this.props.location.pathname)
      this.setState({ loginRedirect: true })
    }
  }

  //dnr
  setMetaData = () => new Promise((resolve, reject) => {
    console.log('setMetaData');

    apiService(
      baseUrl + '/mtt/metadata',
      {},
      data => {
        this.setState({
          flagTemplates: data.flags,
          tournamentTypeTemplates: data.tournamentTypes.sort((a, b) => a.minsToStart - b.minsToStart)
        }, resolve);
      },
      reject
    )
  });

  //dnr
  setFeed = () => new Promise((resolve, reject) => {
    console.log('setFeed')
    apiService(
      baseUrl + '/mtt/feed',
      {},
      data => {
        const { feed, lastFeedUpdateDate } = data;
        this.setState({ feed, lastFeedUpdateDate }, _ => {
          this.setDisplayData();
          resolve();
        });
      },
      reject
    )
  });

  //dnr
  setDisplayData = () => {
    console.log('setDisplayData ');
    let { filters, feed, sortBy, sortColumn } = this.state;
    let filteredTournaments = this.filtertournaments(feed, filters);
    let sortedTournaments = this.sortedTournaments(filteredTournaments, sortBy, sortColumn);
    this.setState({ displayData: sortedTournaments });
  }

  filtertournaments = (tournaments, filters) => {
    return tournaments.filter(tournament =>
      this.applyFilter(tournament, this.parseFilter(filters.BuyIn), 'BuyIn') &&
      this.applyFilter(tournament, this.parseFilter(filters.PrizePool), 'PrizePool') &&
      this.applyFilter(tournament, this.parseFilter(filters.Overlay), 'Overlay') &&
      this.applyFilter(tournament, this.parseFilter(filters.PredictedOverlay), 'PredictedOverlay') &&
      this.applyFilter(tournament, this.parseFilter(filters.minsToStart, 'Date'), 'minsToStart') &&
      this.applyFlagFilter(tournament, filters.flag, 'flag') &&
      this.applyTournamentTypeFilter(tournament, filters.tournamentType, 'tournamentType')
    )
  }

  getCustomFilter = (filters) => {
    const { columnName, min, max } = filters.customFilter;
    let filterText;
    if (min == '' && max == '') filterText = `All`;
    else if (min != '' && max != '') filterText = `bt ${min} ${max}`;
    else if (min != '') filterText = `gt ${min}`
    else if (max != '') filterText = `lt ${max}`
    let filter = columnName == 'minsToStart' ? this.parseFilter(filterText, 'Date') : this.parseFilter(filterText)
    return { filter, columnName }
  }

  applyTournamentTypeFilter = (tournament, filterParams, columnName) => {
    if (filterParams == 'All') return true;
    else {
      const index = tournament.tournamentType.findIndex(type => type.toLowerCase() == filterParams.toLowerCase());
      if (index < 0) return false;
      else return true;
    }
  }

  applyFlagFilter = (tournament, filterParams, columnName) => {
    if (filterParams == 'All') return true;
    else return tournament.flag.name == filterParams
  }

  parseFilter = (filter, type = 'Number') =>
    filter.split(' ').map(param => {
      if (isNaN(param)) return param
      else {
        if (type == 'Date') return parseFloat(param) * 3600000;
        else return parseFloat(param)
      }
    });


  applyFilter = (tournament, filterParams, columnName) => {
    if (filterParams[0] == 'All') {
      return true
    } else {
      let column = tournament[columnName];
      if (filterParams.length == 2) {
        let [identifier, num] = filterParams;
        if (num < 0) {
          num = Math.abs(num)
          column = Math.abs(column)
        }
        if (identifier == 'gt') return column > num;
        else if (identifier == 'lt') return column < num;
      } else if (filterParams.length == 3) {
        let [, num1, num2] = filterParams;
        let col1 = column,
          col2 = column;
        if (num1 < 0) {
          num1 = Math.abs(num1)
          col1 = Math.abs(col1)
        }
        if (num2 < 0) {
          num2 = Math.abs(num2)
          col2 = Math.abs(col2)
        }
        return (col1 > num1) && (col2 < num2)
      }
    }
  }


  getMinsToStart = (date) => {
    const currentTime = moment.tz(tournamentTimezone);
    const time = moment.tz(date, dateFormat, tournamentTimezone);
    return time.diff(currentTime)
  }

  getMinsToStartDisplay = (time) => {
    const duration = moment.duration(Math.abs(time))
    let timeString = `${duration.hours()}:${duration.minutes()}:${duration.seconds()}`
    if (time < 0) return `-${timeString}`;
    else return timeString;
  }

  onSort = (sortColumn) => {
    const sortBy = this.getSortBy(sortColumn);
    const displayData = this.sortedTournaments(this.state.displayData, sortBy, sortColumn);
    this.setState({ sortBy, sortColumn, displayData });
  }

  getSortBy = (sortColumn) => {
    let { sortBy } = this.state;
    if (sortColumn == this.state.sortColumn) {
      if (sortBy == 'asc') sortBy = 'desc'
      else sortBy = 'asc'
    } else {
      sortBy = 'asc'
    }
    return sortBy;
  }

  sortedTournaments = (tournaments, sortBy = 'asc', sortColumn) => {
    if (sortColumn != '') {
      if (sortColumn == 'Name') tournaments.sort(this.sortString(sortColumn, sortBy))
      else if (sortColumn == 'minsToStart' || sortColumn == 'minsToReg') tournaments.sort(this.sortDate(sortColumn, sortBy))
      else tournaments.sort(this.sortNumber(sortColumn, sortBy))
    }
    return tournaments;
  }

  sortDate = (columnName, type) =>
    (a, b) => {
      if (this.getMinsToStartDisplay(a[columnName]) == this.getMinsToStartDisplay(b[columnName])) return 0
      if (type == 'asc') return a[columnName] - b[columnName]
      else if (type == 'desc') return b[columnName] - a[columnName]
    }

  sortNumber = (columnName, type) =>
    (a, b) => {
      if (type == 'asc') return a[columnName] - b[columnName]
      else if (type == 'desc') return b[columnName] - a[columnName]
    }

  sortString = (columnName, type) =>
    (a, b) => {
      let nameA = a[columnName].toUpperCase();
      let nameB = b[columnName].toUpperCase();
      if ((nameA < nameB && type == 'asc') || (nameA > nameB && type == 'desc')) return -1;
      if ((nameA < nameB && type == 'desc') || (nameA > nameB && type == 'asc')) return 1;
      return 0;
    }

  openEditReg = (tournament) => {
    this.setState({
      editTournament: true,
      editTournamentData: {
        ...tournament,
        RegPlayersCount_error: ''
      }
    }, _ => console.log('state set : ' + moment().format('mm:ss')));
  }

  viewTouranment = tournament => this.setState({ viewedTournament: tournament })

  closeTournamentView = _ => this.setState({ viewedTournament: null });

  getTournament = tournamentId => {
    let tournament = this.state.displayData.find(tournament => tournament.tournamentId == tournamentId);
    console.log(`looking for tournament type : ${tournament.appliedTournamentType}`);
    console.log(this.state.tournamentTypeTemplates.map(tt => tt.name));

    const appliedTournamentType = this.state.tournamentTypeTemplates.find(tt => tt.name == tournament.appliedTournamentType)
    return { ...tournament, appliedTournamentType };
  }

  editRegCount_save = () => {
    console.log(':: editRegCount_save ::');
    let { editTournamentData } = this.state;
    console.log(editTournamentData);
    if (isNaN(editTournamentData.RegPlayersCount)) {
      editTournamentData.RegPlayersCount_error = 'RegPlayersCount should be a number';
      this.setState({ editTournamentData });
    } else {

      apiService(
        baseUrl + '/mtt/updateTournament',
        { tournament: editTournamentData },
        data => {
          if (data.status == 'error') {
            editTournamentData.RegPlayersCount_error = data.msg;
            this.setState({ editTournamentData });
          } else {
            this.setFeed().then(this.setState({ editTournament: false }))
          }
        },
        err => {
          console.log(err)
        }
      )
    }
  }

  editRegCount_close = () => this.setState({ editTournament: false });

  editRegCount_change = event => {
    let { editTournamentData } = this.state;
    editTournamentData.RegPlayersCount = event.target.value;
    this.setState({ editTournamentData })
  }

  render() {
    const {
      displayData,
      editTournamentData,
      editTournament,
      flagTemplates,
      lastFeedUpdateDate,
      loading,
      loginRedirect,
      tournamentTypeTemplates,
      viewedTournament
    } = this.state;
    return (
      <div>
        {loginRedirect && (<Redirect to={'/'} />)}
        <EditRegCountDialog
          editRegCount_save={this.editRegCount_save}
          editRegCount_close={this.editRegCount_close}
          editRegCount_change={this.editRegCount_change}
          editTournamentData={editTournamentData}
          open={editTournament}
        />
        {loading ? <Loading /> :
          <div>
            {viewedTournament != null ?
              <OverlayChart
                tournamentId={viewedTournament}
                close={this.viewTouranment}
                getTournament={this.getTournament}
                openEditReg={this.openEditReg}
              />
              : <div>
                <TournamentWatchFilters
                  flags={flagTemplates}
                  tournamentTypes={tournamentTypeTemplates}
                  onSearch={data => this.setState({ filters: data }, this.setDisplayData)}
                  refresh={this.setFeed}
                />
                <div style={{ color: 'white', padding: '1%' }}>
                  <b>Last Feed Update : </b>{lastFeedUpdateDate ? moment(lastFeedUpdateDate).format('DD-MM-YYYY HH:mm:ss') : 'DD-MM-YYYY HH:mm:ss'}
                </div>
                <TournamentWatchDisplay
                  tournaments={displayData}
                  onSort={this.onSort}
                  onView={this.viewTouranment}
                  openEditReg={this.openEditReg}
                />
              </div>
            }
          </div>
        }
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle))
  }
};

export default connect(null, mapDispatchToProps)(TournamentWatch);



/** WEBPACK FOOTER **
 ** ./src/components/TournamentWatch/TournamentWatch.js
 **/